<script setup lang="ts">
import {Button} from "@/Components/Library";
import {useSafeCancel} from "@/Composables/useSafeFormAction.js";
import {useConfirm} from "primevue/useconfirm";

const props = withDefaults(
    defineProps<{
        text?: string;
        icon?: string;
        loading?: boolean;
        showCancel?: boolean;
        isDirty?: boolean;
        confirmIfDirty?: boolean;
        isVertical?: boolean;
    }>(),
    {
        text: "Save",
        loading: false,
        showCancel: true,
        isDirty: false,
        confirmIfDirty: true,
        isVertical: false,
    },
);
const emit = defineEmits(["cancel"]);

const confirm = useConfirm();
const handleCancel = async (event: any) => {
    try {
        const cancel = await useSafeCancel({
            isDirty: !props.confirmIfDirty || props.isDirty,
            event: event,
            confirm: confirm,
        });

        if (cancel) {
            emit("cancel");
        }
    } catch (e) {
        console.log(e);
    }
};
</script>
<template>
    <div class="relative w-full">
        <div
            class="flex flex-col items-center justify-center gap-2 sm:gap-6"
            :class="{
                'sm:flex-row': !isVertical,
            }"
        >
            <slot name="before"></slot>
            <Button
                :pt="{
                    root: {
                        class: 'w-full bg-askr-green text-white hover:brightness-110',
                    },
                }"
                :loading="loading"
                v-bind="$attrs"
                type="submit"
                :icon="{
                    icon: icon ? icon : 'fluent:checkmark-12-regular',
                    width: '24',
                }"
                dusk="save-button"
            >
                {{ text }}
            </Button>
            <Button
                :pt="{
                    root: {
                        class: 'w-full text-red-600 hover:brightness-110',
                    },
                }"
                v-if="showCancel"
                @click="handleCancel"
                text
            >
                Cancel
            </Button>
            <slot name="after"></slot>
        </div>
    </div>
</template>
